import Image from '@tiptap/extension-image'

// Define the attributes interface for our custom image
interface ImageAttributes {
  src?: string
  alt?: string
  title?: string
  width?: string | number | null
  height?: string | number | null
  loading?: string
}

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      width: {
        default: null,
        parseHTML: element => element.getAttribute('width'),
        renderHTML: attributes => {
          if (!attributes.width) {
            return {}
          }
          return {
            width: attributes.width,
            style: `width: ${attributes.width}${attributes.width.toString().includes('%') || attributes.width.toString().includes('px') ? '' : 'px'}`,
          }
        },
      },
      height: {
        default: null,
        parseHTML: element => element.getAttribute('height'),
        renderHTML: attributes => {
          if (!attributes.height) {
            return {}
          }
          return {
            height: attributes.height,
            style: `height: ${attributes.height}${attributes.height.toString().includes('%') || attributes.height.toString().includes('px') ? '' : 'px'}`,
          }
        },
      },
      loading: {
        default: 'lazy',
      },
    }
  },

  addCommands() {
    return {
      setImage: (options: ImageAttributes) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
      updateImage: (options: Partial<ImageAttributes>) => ({ commands }) => {
        return commands.updateAttributes(this.name, options)
      },
    }
  },
})